import type { IUnsplashImage } from "@/shared/types";
import { IMAGES_PANEL_MASONRY_COLS } from "../constants";
import type { IImagesPanelImage } from "../types";

const COLS = IMAGES_PANEL_MASONRY_COLS;

interface IProps {
  images: IUnsplashImage[];
  extend?: boolean;
}

export const stockImagesToCols = ({ images, extend }: IProps) => {
  return (prev: IImagesPanelImage[][]) => {
    const imgs: IImagesPanelImage[] = images.map((img) => ({
      id: img.id,
      url: img.urls.regular,
      thumbUrl: img.urls.thumb,
      alt: img.alt_description,
      col: img.alt_description,
      width: img.width,
      height: img.height,
      userName: img.user.name,
      userUrl: img.user.links.html,
      imageBlurhash: img.blur_hash,
    }));

    if (extend) {
      const currentColumns: IImagesPanelImage[][] = Array.from(
        { length: COLS },
        (_, idx) => [...(prev[idx] ?? [])],
      );

      imgs.forEach((vid, index) => {
        const totalItems = prev.reduce((sum, col) => sum + col.length, 0);
        const columnIndex = (totalItems + index) % COLS;
        currentColumns[columnIndex].push(vid);
      });
      return currentColumns;
    }

    const newColumns: IImagesPanelImage[][] = Array.from(
      { length: COLS },
      () => [],
    );
    imgs.forEach((vid, index) => {
      const columnIndex = index % COLS;
      newColumns[columnIndex].push(vid);
    });
    return newColumns;
  };
};
